export default "__VITE_ASSET__zKzM3RhH__"